
const digest = '680da7cd8f676e1d75b5d854964dc33706f9c6db0f179d8275a53c7d0bd063c4';
const classes = {"item":"_item_1y6ii_1","content":"_content_1y6ii_9","validBall":"_validBall_1y6ii_15","expiredBall":"_expiredBall_1y6ii_22","title":"_title_1y6ii_29","description":"_description_1y6ii_37","controls":"_controls_1y6ii_40"};
const css = `._item_1y6ii_1 {
  border: 1px solid #d1d4da;
  border-radius: 3px;
  display: flex;
  flex-direction: row;
  padding: 24px;
  justify-content: space-between;
}
._item_1y6ii_1 ._content_1y6ii_9 {
  display: flex;
  flex-direction: row;
  gap: 5px;
  align-items: center;
}
._item_1y6ii_1 ._content_1y6ii_9 ._validBall_1y6ii_15 {
  width: 9px;
  height: 9px;
  border-radius: 100%;
  margin-right: 10px;
  background-color: #619612;
}
._item_1y6ii_1 ._content_1y6ii_9 ._expiredBall_1y6ii_22 {
  width: 9px;
  height: 9px;
  border-radius: 100%;
  margin-right: 10px;
  background-color: #f12848;
}
._item_1y6ii_1 ._content_1y6ii_9 ._title_1y6ii_29 {
  color: #1665d8;
  font-size: 16px;
  font-weight: 600;
}
._item_1y6ii_1 ._content_1y6ii_9 ._title_1y6ii_29 span {
  font-weight: 400;
}
._item_1y6ii_1 ._content_1y6ii_9 ._description_1y6ii_37 {
  font-size: 14px;
}
._item_1y6ii_1 ._controls_1y6ii_40 {
  display: flex;
  flex-direction: row;
  gap: 10px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  